var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_17861",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 17861",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_17861-2",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 17861",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5364",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5364",
    d: "M4,1A3,3,0,0,0,1,4V25a3,3,0,0,0,3,3H30a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H4M4,0H30a4,4,0,0,1,4,4V25a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(0 3)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5366",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5366",
    width: 4,
    height: 7,
    rx: 2,
    transform: "translate(7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5366_-_\\u0420\\u0430\\u043C\\u043A\\u0430",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5366 - \\u0420\\u0430\\u043C\\u043A\\u0430",
    d: "M2,1A1,1,0,0,0,1,2V5A1,1,0,0,0,3,5V2A1,1,0,0,0,2,1M2,0A2,2,0,0,1,4,2V5A2,2,0,0,1,0,5V2A2,2,0,0,1,2,0Z",
    transform: "translate(7)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5367",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5367",
    width: 4,
    height: 7,
    rx: 2,
    transform: "translate(23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5367_-_\\u0420\\u0430\\u043C\\u043A\\u0430",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5367 - \\u0420\\u0430\\u043C\\u043A\\u0430",
    d: "M2,1A1,1,0,0,0,1,2V5A1,1,0,0,0,3,5V2A1,1,0,0,0,2,1M2,0A2,2,0,0,1,4,2V5A2,2,0,0,1,0,5V2A2,2,0,0,1,2,0Z",
    transform: "translate(23)",
    fill: "#1d1d1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_621",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 621",
    d: "M33.05.5H0v-1H33.05Z",
    transform: "translate(0.5 11.413)",
    fill: "#1d1d1f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_247626",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 247626",
    d: "M411.743,490.23l-7.794,7.8-2.72-2.721a.632.632,0,0,0-.894.894l3.171,3.171a.622.622,0,0,0,.45.184.65.65,0,0,0,.45-.184l8.244-8.244a.632.632,0,0,0,0-.894A.647.647,0,0,0,411.743,490.23Z",
    transform: "translate(-388.688 -474.188)",
    fill: "#1d1d1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.de7495ad9373f527baf04d31a22e2582.svg";
export { ForwardRef as ReactComponent };